import gql from 'graphql-tag'

export const getPopularSearchesQuery = gql`
  query getOrganizationAnalytics($period: AnalyticsPeriod!) {
    getOrganizationAnalytics(period: $period) {
      popularSearches {
        search
        count
        popularMatchingNote(period: $period) {
          id
          title
        }
      }

      popularSearchesWithoutResults {
        search
        count
      }
    }
  }
`

export const getPopularNotesQuery = gql`
  query getOrganizationAnalytics($period: AnalyticsPeriod!) {
    getOrganizationAnalytics(period: $period) {
      popularNotes {
        note {
          id
          title
        }
        count
      }
    }
  }
`

export const getTeamActivityQuery = gql`
  query getOrganizationAnalytics($period: AnalyticsPeriod!) {
    getOrganizationAnalytics(period: $period) {
      topReaders {
        user {
          id
          displayName
        }
        count
      }

      topWriters {
        user {
          id
          displayName
        }
        count
      }
    }
  }
`
